import { render, staticRenderFns } from "./jd_agent_company.vue?vue&type=template&id=726064f8&scoped=true&"
import script from "./jd_agent_company.vue?vue&type=script&lang=js&"
export * from "./jd_agent_company.vue?vue&type=script&lang=js&"
import style0 from "./jd_agent_company.vue?vue&type=style&index=0&id=726064f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726064f8",
  null
  
)

export default component.exports